import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  () => ({
    root: {
      color: COLORS.gray.gray30,
    },
  }),
  { name: 'GenerationToolIcon' }
);
